import BulkAction from "../ContactList/BulkActions/BulkAction";
import FA from "../../utils/FA";
import React from 'react';
import {connect} from "react-redux";
import {faTag} from "@fortawesome/pro-regular-svg-icons/faTag";
import {faTimes} from "@fortawesome/pro-solid-svg-icons/faTimes";
import {modals} from "../../ducks";
import PropTypes from "prop-types";
import TagType from "../../propTypes/tagType";

const mapDispatchToProps = (dispatch) => ({
  showBulkTagModal: (modalProps) => dispatch(modals.actions.show('BulkTagModal', modalProps))
});

/**
 * Bulk add tags to taggable objects, using BulkTagModal.
 *
 * BulkTagModal must be loaded into a ModalRoot by caller.
 */
export const BulkTagAction = connect(null, mapDispatchToProps)(
  (
    {
      itemDescription,
      onSubmit,
      showBulkTagModal,
      tags,
      ...props
    }
  ) =>
    <BulkAction
      title='Add tags'
      icon={faTag}
      onClick={() => showBulkTagModal({
        action: 'add',
        itemDescription,
        onSubmit,
        tags,
      })}
      {...props}
    />
);

BulkTagAction.propTypes = {
  /** Description of selected items to display in modal */
  itemDescription: PropTypes.string,

  /** Callback invoked with tags to add */
  onSubmit: PropTypes.func,

  /** Tags that can be added */
  tags: PropTypes.arrayOf(TagType).isRequired
};

/**
 * Bulk remove tags from taggable objects, using BulkTagModal.
 *
 * BulkTagModal must be loaded into a ModalRoot by caller.
 */
export const BulkUntagAction = connect(null, mapDispatchToProps)(
  (
    {
      itemDescription,
      onSubmit,
      showBulkTagModal,
      tags,
      ...props
    }
  ) =>
    <BulkAction
      title='Remove tags'
      iconComponent={
        () => <React.Fragment>
                <span className="fa-layers fa-fw">
                  <FA icon={faTag}/>
                  <FA icon={faTimes} transform="shrink-10"/>
                </span>
          {' '}
        </React.Fragment>
      }
      onClick={() => showBulkTagModal({
        action: 'remove',
        itemDescription,
        onSubmit,
        tags,
      })}
      {...props}
    />
);

BulkUntagAction.propTypes = {
  /** Description of selected items to display in modal */
  itemDescription: PropTypes.string,

  /** Callback invoked with tags to remove */
  onSubmit: PropTypes.func,

  /** Tags that can be removed */
  tags: PropTypes.arrayOf(TagType).isRequired
};
